import russian from './messages-ru';
import english from './messages-en';

export const messages = {
  ...russian,
  ...english,
};
